import { config } from 'api';
import errorHandler from 'utils/errorHandler';

import { isCitrusAdEnabled } from 'apps/analytics/utils/citrusAd';

export const ADD_CITRUS_BANNER = 'ADD_CITRUS_BANNER';

const getApiURL = ({ searchTerm, tags }) => {
  const apiUrlBase = `${config.apiHost}/webshop/api/v2/ads`;

  if (searchTerm) {
    return `${apiUrlBase}/search/${searchTerm}`;
  }

  return `${apiUrlBase}/catalogue?categories=${tags.join(',')}`;
};

const loadCitrusBanner = (url, routeString) => {
  const citrusBannerAction = {
    type: ADD_CITRUS_BANNER,
    route: routeString,
  };

  return (dispatch, getState, { network }) =>
    network.get(url)
      .then(banners => dispatch({ ...citrusBannerAction, banners }))
      .catch(errorHandler);
};

export function loadCitrusBannerForSearch(betaFeatures, searchTerm, routeString) {
  if (!isCitrusAdEnabled(betaFeatures) || !searchTerm) {
    return () => Promise.resolve();
  }

  return loadCitrusBanner(
    getApiURL({ searchTerm }), routeString
  );
}

export function loadCitrusBannerForCategory(betaFeatures, tags, routeString) {
  if (!isCitrusAdEnabled(betaFeatures) || !tags || !tags.length) {
    return () => Promise.resolve();
  }

  return loadCitrusBanner(
    getApiURL({ tags }), routeString
  );
}
